import Image from 'next/image'
import styled from 'styled-components'

export const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`
